import { Component, inject } from '@angular/core';
import { injectDispatch } from '@ngrx/signals/events';
import { Divider } from 'primeng/divider';
import {
  offshoreOperationalEvents,
  OffshoreOperationalFormStore,
  OffshoreReportStore,
} from '@navstation-portal/reporting/data-access/offshore-report';
import { DynamicFormComponent } from '../shared/dynamic-form/dynamic-form.component';
import { OffshoreReportingOptionsComponent } from './sections/offshore-reporting-options/offshore-reporting-options.component';
import { ReportTimeComponent } from './sections/report-time/report-time.component';
import { VesselDetailsComponent } from './sections/vessel-details/vessel-details.component';
import { PortAndPositionComponent } from './sections/port-and-position/port-and-position.component';
import { StabilityConditionsComponent } from './sections/stability-conditions/stability-conditions.component';
import { MiscellaneousComponent } from './sections/miscellaneous/miscellaneous.component';
import { PortOperationsTimestampComponent } from './sections/port-operations-timestamp/port-operations-timestamp.component';
import { OperatingConditionsComponent } from './sections/operating-conditions/operating-conditions.component';
import { NextPortComponent } from './sections/next-port/next-port.component';
import { ReportDetailsComponent } from './sections/report-details/report-details.component';
import { VoyageDetailsComponent } from './sections/voyage-details/voyage-details.component';
import { CrewAndPassengersComponent } from './sections/crew-and-passengers/crew-and-passengers.component';

@Component({
  selector: 're-offshore-operational',
  standalone: true,
  templateUrl: './offshore-operational.component.html',
  imports: [
    VesselDetailsComponent,
    ReportTimeComponent,
    PortAndPositionComponent,
    StabilityConditionsComponent,
    MiscellaneousComponent,
    PortOperationsTimestampComponent,
    OperatingConditionsComponent,
    NextPortComponent,
    DynamicFormComponent,
    ReportDetailsComponent,
    VoyageDetailsComponent,
    CrewAndPassengersComponent,
    Divider,
    OffshoreReportingOptionsComponent,
  ],
})
export class OffshoreOperationalComponent {
  events = injectDispatch(offshoreOperationalEvents);
  operationalStore = inject(OffshoreOperationalFormStore);
  offshoreReportStore = inject(OffshoreReportStore);
}
